export default "__VITE_PUBLIC_ASSET__145e23f1__"